import React from "react";
import { render } from "Utils/react-utils";
import { Provider } from "react-redux";
import store from "../../store";
import PublicNav from "Components/landing/home/PublicNav";

import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "../../context/theme";

export async function initPublicNav() {
	const publicNavEl = document.querySelector("#public-nav");
	const option = window.location.pathname.startsWith("/blog") ? "grayscale(0.3) blur(6px)" : "blur(10px)";
	const menuStyle = { backdropFilter: option };
	if (publicNavEl) {
		render(
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<StyledEngineProvider injectFirst>
						<PublicNav menuStyle={menuStyle} />
					</StyledEngineProvider>
				</ThemeProvider>
			</Provider>,
			publicNavEl,
		);
	}
}
